<template>
  <div class="text">
    <p>You are already logged in as Company user</p>
    <p>Do you want to logout and login as Application user ?</p>
    <el-button type="primary" class="mt-1" @click="logoutUser"
      >Logout</el-button
    >
  </div>
</template>
<script>
import applicationUsersForbidden from "@/mixins/applicationUsersForbidden";
export default {
  name: "ApplicationUsersForbidden",
  mixins: [applicationUsersForbidden],
};
</script>
<style scoped>
.text {
  font-size: 18px;
  color: red;
  height: 100vh;
  margin-top: 30vh;
  /* display: flex; */
  text-align: center;
}
</style>
